/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';
import { useDispatch } from 'react-redux';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';
import MoreButton from '@components/navbar/MoreButton';

import CatalogScreen from '@/screens/catalog/CatalogScreen';
import CatalogBrandScreen from '@/screens/catalog/CatalogBrandScreen';
import CatalogPromoScreen from '@/screens/catalog/CatalogPromoScreen';
import CatalogCategoriesScreen from '@/screens/catalog/CatalogCategoriesScreen';
import { showPopup } from '@/store/modal';

const Stack = createStackNavigator();

const CatalogNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();

  return (
    <Stack.Navigator
      initialRouteName="CatalogScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="CatalogScreen"
        component={CatalogScreen}
        options={(props) => {
          const menus = [];
          menus.push({
            type: 'function',
            name: 'Export',
            callback: () =>
              dispatch(
                showPopup({ name: 'showCatalogExportMenu', value: true }),
              ),
          });
          return {
            title: setTitleHeader('Product Catalog'),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : (
                <MoreButton menu={menus} {...props} />
              ),
          };
        }}
      />
      <Stack.Screen
        name="CatalogBrandScreen"
        component={CatalogBrandScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Product Brand';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          const goBack = () => {
            props.navigation.navigate('CatalogScreen', { tab: '' });
          };
          const menus = [];
          menus.push({
            type: 'function',
            name: 'Export',
            callback: () =>
              dispatch(showPopup({ name: 'showBrandExportMenu', value: true })),
          });
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton {...props} onPress={() => goBack()} />
            ),
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : (
                <MoreButton menu={menus} {...props} />
              ),
          };
        }}
      />
      <Stack.Screen
        name="CatalogPromoScreen"
        component={CatalogPromoScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Product Promo';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          const goBack = () => {
            props.navigation.navigate('CatalogScreen', { tab: 'promo' });
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton {...props} onPress={() => goBack()} />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
      <Stack.Screen
        name="CatalogCategoriesScreen"
        component={CatalogCategoriesScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Product Categories';
          if (route.params && route.params.titleScreen) {
            title = route.params.titleScreen;
          }
          const goBack = () => {
            props.navigation.navigate('CatalogScreen', { tab: '' });
          };
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton {...props} onPress={() => goBack()} />
            ),
            headerRight: () =>
              isWeb ? <NotificationSettingButton {...props} /> : false,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default CatalogNavigator;
